import { Sidebar } from './Sidebar';
import { SidebarSection } from './SidebarSection';
import { SidebarClose } from './SidebarClose';
import { SidebarMobileFluid } from './SidebarMobileFluid';
import { SidebarShowSlim } from './SidebarShowSlim';
import { SidebarHideSlim } from './SidebarHideSlim';

Sidebar.Section = SidebarSection;
Sidebar.Close = SidebarClose;
Sidebar.MobileFluid = SidebarMobileFluid;
Sidebar.ShowSlim = SidebarShowSlim;
Sidebar.HideSlim = SidebarHideSlim;

export default Sidebar;